<template>
    <div id="teethListContainer" class="teeth-ctrls panel-group teeth-list-ctrl">
        <div id="teethListPanel" ref="teethListPanel" class="collapse list-group teeth-panel ">
            <div class="teeth-settings">
                <li v-if="!isNoTeeth && !isViewMode" class="list-group-item setting-item active">Settings</li>
                <li v-if="!isNoTeeth && !isViewMode" class="list-group-item setting-item">
                    <!-- <input type="range" class="form-control-range"> -->
                    <button type="button" class="btn btn-secondary btn-sm btn-block setting-btn"
                        v-on:click="addTooth">Add Tooth</button>
                </li>
                <li v-if="!isNoTeeth" class="list-group-item setting-item active">Teeth Visibility</li>
                <li v-if="!isNoTeeth" class="list-group-item setting-item visibiltiy-group">

                    <button id="btnViewOnlyTeeth" type="button" class="btn btn-primary btn-sm btn-block setting-btn"
                        v-on:click="viewOnlyTeeth">View Only Teeth</button>

                    <!-- <div class="mb-2 mt-1 setting-group"> -->
                    <label v-for="option in visibilities" class="setting-ctrl">
                        <span class="check-label">{{ option.text }}</span>
                        <input type="checkbox" class="check-input" v-model="option.value"
                            @change="visibilityChanged(option.key, option.value)">
                    </label>

                    <label v-if="hasClosedBones" class="setting-ctrl">
                        <span class="check-label">Color Teeth Roots</span>
                        <input type="checkbox" class="check-input" v-model="showTeethRoots"
                            @change="showTeethRootsChanged()">
                    </label>

                    <label v-if="isOcclusionAvailable" class="setting-ctrl">
                        <span class="check-label">Snap To Occlusion</span>
                        <input type="checkbox" class="check-input" v-model="localSnapToOcclusion"
                            @change="snapToOcclusionChanged()">
                    </label>

                    <div v-if="isStitched" class="source-type-group">
                        <img v-show="isSwitchStitching" class="switch-stitching-img"
                            src="images/dark-blue-spinner.gif" />
                        <label class="source-type-label">
                            <input id="rbCbctSourceType" class="source-type-rb" type="radio" name="sourceType"
                                value="cbct" @click="sourceTypeChanged('cbct')" v-model="localSourceType">
                            <span class="source-type-span">CBCT</span>
                        </label>
                        <label class="source-type-label">
                            <input id="rbStitchedSourceType" class="source-type-rb" type="radio" name="sourceType"
                                value="stitched" @click="sourceTypeChanged('stitched')" v-model="localSourceType">
                            <span class="source-type-span">Stitched</span>
                        </label>
                    </div>

                    <div class="teeth-opacity-div">
                        <span>Opacity</span>
                        <!-- <img class="img-teeth-opacity" :src="'images/opacity_icon.png'" title="Opacity"/> -->
                        <input id="teethOpacityRange" type="range" class="form-range teeth-opacity-range" min="0"
                            max="1" step="0.01" @input="applyOpacityChange()" v-model="localTeethOpacity">
                    </div>

                    <!-- </div> -->
                </li>
                <li v-if="!isNoTeeth" class="list-group-item setting-item active">Teeth Naming</li>
                <li v-if="!isNoTeeth && !isViewMode" class="list-group-item setting-item">
                    <!-- <input type="range" class="form-control-range"> -->
                    <select v-model="teethNamingLocal" class="form-control form-control-sm"
                        @change="teethNamingChanged()">
                        <option v-for="option in teethNamings" v-bind:value="option.value">
                            {{ option.text }}
                        </option>
                    </select>
                </li>

                <li v-if="hasSolidBones" class="list-group-item setting-item active">Bones</li>
                <li v-if="hasSolidBones" class="list-group-item setting-item visibiltiy-group">
                    <label v-if="hasSolidBones" class="setting-ctrl">
                        <span class="check-label">Solid Bones</span>
                        <input name="bones-type" type="radio" class="check-input" value="solid" v-model="localBonesType"
                            @change="bonesTypeChanged()">
                    </label>

                    <label v-if="hasFullBones" class="setting-ctrl">
                        <span class="check-label">Full Bones</span>
                        <input name="bones-type" type="radio" class="check-input" value="full" v-model="localBonesType"
                            @change="bonesTypeChanged()">
                    </label>

                     <!-- Original bones -->
                    <label v-if="hasSolidBones" class="setting-ctrl">
                        <span class="check-label">Unfiltered Bones</span>
                        <input name="bones-type" type="radio" class="check-input" value="default"
                            v-model="localBonesType" @change="bonesTypeChanged()">
                    </label>
                </li>

                <li id="multiselectHeader" class="list-group-item setting-item active" v-on:click="multiselectClick">
                    <img id="multiselectImg" src="images/select_multiple_icon.png"> Elements
                </li>
            </div>
            <div id="teethList" class="teeth-list" ref="teethList"></div>
            <div class="teeth-list-bottom">
                <button type="button" class="btn btn-primary btn-sm btn-block cancel-btn" v-on:click="close">Hide Panel
                </button>
            </div>
        </div>
    </div>
</template>

<script>

import swal from "sweetalert";

import { showToothAddDialog } from "@/components/tooth/add/ToothAddMode";
import { ISO, UNS, ALPHANUM, updateTeethNaming } from "@/components/tooth/teethNaming.js";
import { switchStitching } from "@/components/appStart/stitching";
import { showMultiselect } from "./MultiselectManager";
import {
    DEFAULT_BONES_TYPE,
    SOLID_BONES_TYPE,
    FULL_BONES_TYPE,
    switchTeethRoots, snapMandibleToOcclusion, switchBonesType
} from "./TeethListManager";
import { getMeshesBox } from "@/components/anchorage/AnchorageCalculation";

const ONLY_TEETH = "OnlyTeeth";

export default {
    name: "TeethListPanel",
    props: {
        allItems: {
            type: Array,
            required: false
        },
        isOnlyTeeth: {
            type: Boolean,
            required: true
        },
        isNoTeeth: {
            type: Boolean,
            required: true
        },
        isViewMode: {
            type: Boolean,
            required: true
        },
        isStitched: {
            type: Boolean,
            required: true
        },
        isOcclusionAvailable: {
            type: Boolean,
            required: true
        },
        hasClosedBones: {
            type: Boolean,
            required: true
        },
        hasSolidBones: {
            type: Boolean,
            required: true
        },
        hasFullBones: {
            type: Boolean,
            required: true
        },
        isStitching: {
            type: Boolean,
            required: true
        },
        isMaxillaVisible: {
            type: Boolean,
            required: true
        },
        isMandibleVisible: {
            type: Boolean,
            required: true
        },
        isDicomOpen: {
            type: Boolean,
            required: true
        },
        snapToOcclusion: {
            type: Boolean,
            required: true
        },
        viewSourceType: {
            type: String,
            required: true
        },
        teethOpacity: {
            required: true
        },
        teethNaming: {
            required: true
        },
        bonesType: {
            required: true
        },
    },
    watch: {
        "viewSourceType": {
            handler(newVal, oldVal) {
                this.localSourceType = newVal;
            }
        },
        "teethOpacity": {
            handler(newVal, oldVal) {
                this.localTeethOpacity = +newVal;
            }
        },
        "snapToOcclusion": {
            handler(newVal, oldVal) {
                this.localSnapToOcclusion = newVal;
            }
        },
        "bonesType": {
            handler(newVal, oldVal) {
                console.log("watch bonesType", newVal);
                this.localBonesType = newVal;
            }
        },
        "isMaxillaVisible": {
            handler(newVal, oldVal) {
                console.log("isMaxillaVisible", newVal);
                let visibility = this.visibilities[0];
                if (visibility.value != newVal) {
                    visibility.value = newVal;
                    // this.visibilityChanged(visibility.key, visibility.value);
                }
            }
        },
        "isMandibleVisible": {
            handler(newVal, oldVal) {
                console.log("isMandibleVisible", newVal);
                let visibility = this.visibilities[1];
                if (visibility.value != newVal) {
                    visibility.value = newVal;
                    // this.visibilityChanged(visibility.key, visibility.value);
                }
            }
        },
    },
    data() {
        return {
            showTeethRoots: false,
            localBonesType: DEFAULT_BONES_TYPE,
            visibilities: [
                { text: "Max Teeth", key: "Maxilla", value: true },
                { text: "Mand Teeth", key: "Mandible", value: true },
            ],
            teethNamings: [
                { text: "ISO 3950", value: ISO },
                { text: "UNS", value: UNS },
                { text: "Alphanum.", value: ALPHANUM }
            ],
            localSourceType: 'cbct',
            localTeethOpacity: 1,
            localSnapToOcclusion: false,
            isSwitchStitching: false,
            isFirstSwitch: true
        }
    },
    methods: {
        snapToOcclusionChanged: function () {
            if (vueApp.snapToOcclusion == this.localSnapToOcclusion) {
                return;
            }
            vueApp.snapToOcclusion = this.localSnapToOcclusion;
            snapMandibleToOcclusion(vueApp.snapToOcclusion);
        },
        showTeethRootsChanged: function () {
            switchTeethRoots(this.showTeethRoots);
        },
        bonesTypeChanged: function () {
            switchBonesType(this.localBonesType);
        },
        sourceTypeChanged: function (sourceType) {
            // var sourceType = this.localSourceType; // $('input[name="sourceType"]:checked').val();
            console.log("sourceTypeChanged", new Date(), sourceType);
            if (vueApp.viewSourceType == sourceType) {
                return;
            }
            // this.localSourceType = vueApp.viewSourceType = sourceType;
            // switchStitching(sourceType);
            if (vueApp.isStitching) {
                // if (this.localSourceType != 'cbct') {
                console.log('localSourceType', this.localSourceType);
                this.localSourceType = 'cbct';
                $("#rbCbctSourceType").prop("checked", true);
                $("#rbStitchedSourceType").prop("checked", false);
                // }
                swal({
                    text: "Cannot switch to stitched view while post processing.",
                });
            } else {
                vueApp.viewSourceType = vueApp.savedData.viewSourceType = sourceType;
                this.isSwitchStitching = true; // this.isFirstSwitch;
                console.log("isSwitchStitching", new Date(), sourceType);
                if (this.isFirstSwitch) {
                    setTimeout(() => {
                        // vueApp.saveData();
                        switchStitching(sourceType);
                        this.isSwitchStitching = false;
                    }, 500);
                    this.isFirstSwitch = false;
                } else {
                    // vueApp.saveData();
                    switchStitching(sourceType);
                    this.isSwitchStitching = false;
                }
            }
        },
        teethNamingChanged: function () {
            // vueApp.isMaxillaVisible = false;
            // updateTeethNaming(this.teethNamingLocal);
        },
        applyOpacityChange: function () {
            vueApp.teethOpacity = +this.localTeethOpacity;
            vueApp.allTeeth.forEach(tooth => {
                viewer.set_opacity(tooth.id, vueApp.teethOpacity);
            });
        },
        addTooth: function () {
            showToothAddDialog();
        },
        viewOnlyTeeth: function () {
            vueApp.bones.concat(vueApp.nerves).concat(vueApp.gingivae)
                .concat(vueApp.airways).forEach(function (item) {
                    item.isVisible = false;
                    let actualColor = vueApp.getActualColor(item);
                    itemVisibilityChanged(item, actualColor, item.opacity)
                });
            vueApp.$emit('visibilityChanged', { name: ONLY_TEETH, isVisible: false });
        },
        close: function () {
            console.log("close teethListPanel");
            // $(`#teethListPanel`).css({
            //     display: "none",
            // });
            $(`#teethListPanel`).removeClass("show");
        },
        visibilityChanged: function (key, value) {
            let arr = [];

            this.visibilities.forEach(option => {
                let dentitionName = option.key;
                if (option.value) {
                    arr.push(dentitionName);
                }
                var dentation = vueApp.dentations.find(x => x.name === dentitionName);
                if (dentation) {
                    dentation.isVisible = option.value;
                    if (dentation.name === this.visibilities[0].key) {
                        vueApp.isMaxillaVisible = dentation.isVisible;
                    }
                    if (dentation.name === this.visibilities[1].key) {
                        vueApp.isMandibleVisible = dentation.isVisible;
                    }
                    vueApp.allTeeth.forEach(function (item) {
                        if (item.dentition == dentitionName && (!item.isHidden || !dentation.isVisible)) { //(dentationTeeth.includes(item)) {
                            item.isVisible = dentation.isVisible;
                            let actualColor = vueApp.getActualColor(item);
                            itemVisibilityChanged(item, actualColor, vueApp.teethOpacity)
                        }
                    });
                }
            });

            let visibleItems = vueApp.allItems.filter((x) => x.isVisible);
            let visibleMeshes = visibleItems.map((x) => viewer.get_model_mesh(x.id));
            let visibleBox = getMeshesBox(visibleMeshes);
            vueApp.lookAtPoint(visibleBox.center);

            vueApp.$emit('visibilityChanged', { name: key, isVisible: value });
            console.log("visibilityChanged", key, value, arr);
        },
        multiselectClick: function () {
            showMultiselect();
        }
    },
    mounted() {
        // console.log("TeethListPanel mounted");
        // this.localBonesType = vueApp.bonesType;
    },
    computed: {
        teethNamingLocal: {
            get: function () {
                return this.teethNaming;
            },
            set: function (value) {
                // console.log("set teethNamingLocal", value);
                vueApp.teethNaming = value;
                updateTeethNaming(vueApp.teethNaming);
            }
        }
    }
}

</script>

<style scoped>
/*********** Baseline, reset styles ***********/
input[type="range"] {
    -webkit-appearance: none;
    appearance: none;
    background: transparent;
    cursor: pointer;
}

/* Removes default focus */
input[type="range"]:focus {
    outline: none;
}

/******** Chrome, Safari, Opera and Edge Chromium styles ********/
/* slider track */
input[type="range"]::-webkit-slider-runnable-track {
    background-color: #ffffff;
    border-radius: 0.5rem;
    border-color: black;
    height: 0.5rem;
}

/* slider thumb */
input[type="range"]::-webkit-slider-thumb {
    -webkit-appearance: none;
    /* Override default look */
    appearance: none;
    margin-top: -4px;
    /* Centers thumb on the track */
    background-color: #ffffff;
    border-radius: 0.5rem;
    border-color: black;
    height: 1rem;
    width: 1rem;
}

input[type="range"]::-webkit-slider-thumb {
    outline: 1px solid #9e9e9e;
}

/*********** Firefox styles ***********/
/* slider track */
input[type="range"]::-moz-range-track {
    background-color: #ffffff;
    border-radius: 0.5rem;
    height: 0.5rem;
}

/* slider thumb */
input[type="range"]::-moz-range-thumb {
    background-color: #ffffff;
    border: none;
    /*Removes extra border that FF applies*/
    border-radius: 0.5rem;
    height: 1rem;
    width: 1rem;
}

input[type="range"]::-moz-range-thumb {
    outline: 1px solid #9e9e9e;
    /* outline-offset: 0.125rem; */
}
</style>

<style scoped>
/* @import "../../css/slider.css"; */

#btnViewOnlyTeeth {
    margin-bottom: 3px;
}

.teeth-opacity-div {
    display: flex;
    /* align-items: stretch; */
    gap: 5px;
    /* margin-left: 3px; */
}

.teeth-opacity-range {
    /* margin-top: 5px; */
    width: 80%;
}

.img-teeth-opacity {
    cursor: pointer;
    margin-top: 0px;
    height: 24px;
    width: 24px;
}

#multiselectHeader {
    cursor: pointer;
}

#multiselectImg {
    width: 23px;
    height: 23px;
}

.visibiltiy-group {
    color: white;
    background-color: #77a7fd;
}

.source-type-group {
    vertical-align: middle;
    min-height: 25px;
    height: 25px;
    margin-top: 5px;
    text-align: right;
}

.source-type-label {
    display: inline-block;
    margin-left: 8px;
    margin-top: 2px;
    /* height: 25px; */
}

.source-type-span {
    vertical-align: middle;
}

.source-type-rb {
    margin-right: 3px;
    vertical-align: middle;
}

.switch-stitching-img {
    display: inline;
    width: 25px;
    height: 25px;
}

#teethListContainer {
    display: none;
    z-index: 1000;
}

.btn {
    font-size: small;
}

.setting-group {
    text-align: right;
    border: 1px solid #ced4da;
    align-items: end;
    border-radius: 0.2rem;
    padding-right: 5px;
}

.setting-ctrl {
    text-align: right;
    display: block;
    white-space: nowrap;
    margin: 0;
}

.check-label {
    margin-right: 0.5rem;
    vertical-align: middle;
}

.check-input {
    /* margin-top: 20px; */
    vertical-align: middle;
}

.teeth-ctrls {
    position: absolute;
    top: 10px;
    right: 45px;
    z-index: 9;
    text-align: right;
    height: calc(100vh - 45px);
    width: 0;
    font-family: Montserrat, sans-serif;
    font-size: small;
    background-color: red;
    overflow: visible;
}

.teeth-panel {
    /* border-radius: 0.25rem;  */
    position: absolute;
    width: 200px;
    right: -40px;
    top: 30px;
    max-height: calc(100% - 40px);
    overflow-y: scroll;
    border-top-right-radius: 0.25rem;
    border-top-left-radius: 0.25rem;
    border-bottom-right-radius: 0.25rem;
    border-bottom-left-radius: 0.25rem;
    /* border: solid 1px white; */
}

.teeth-settings {
    width: 100%;
    background: #77a7fd;
    border-top-right-radius: 0.25rem;
    border-top-left-radius: 0.25rem;
}

.setting-item {
    text-align: center;
    padding: .3rem .4rem;
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
}

.setting-btn {
    margin: 2px 0;
    padding: 0;
}

.teeth-list {
    background: white;
    /* #77a7fd; */
    overflow-y: scroll;
    /* max-height: calc(100% - 120px); */
    width: 100%;
    /* calc(100% - 1px); */
    /* margin-left: 1px;
    margin-top: 1px; */
}

.teeth-list-bottom {
    padding-bottom: 8px;
    background-color: white;
    width: 100%;
    border-bottom-right-radius: 0.25rem;
    border-bottom-left-radius: 0.25rem;
    border: 1px solid rgba(0, 0, 0, .125);
}

.apply-btn {
    margin: 0px 5px 0 5px;
    width: calc(100% - 10px);
}

.cancel-btn {
    margin: 8px 5px 0px 5px;
    width: calc(100% - 10px);
}

::-webkit-scrollbar {
    width: 5px;
}

::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px transparent;
    border-radius: 10px;
}

::-webkit-scrollbar-thumb {
    background: transparent;
    border-radius: 10px;
}

::-webkit-scrollbar-thumb:hover {
    background: #007bff;
}
</style>